import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

window.theme = {
    globals: {
        enablePjax: true
    },
    debug: function( message, type = 'default' ) {
        if ( themeVars.debug !== undefined && themeVars.debug === '1' ) {
            var style = 'background: #59bcf0; font-weight: bold; color: #fff',
                prefix = ' Info: ';

            switch ( type ) {
                case 'error':
                    prefix = ' Error: '
                    style = 'background: #ed1111; font-weight: bold; color: #fff';
                    break;
                case 'success':
                    prefix = ' Success: '
                    style = 'background: #43d896; font-weight: bold; color: #fff';
                    break;
            }

            console.log( '%c ' + prefix + message + ' ', style );
        }
    },
    init: function() {
        var theme = this;
        //Content

        theme.content.init();

        setTimeout( function() {
            $( document.body ).removeClass( 'preloading' );
        }, 500 );

        $( document.body ).addClass( 'pointer-device' );

        $( document.body ).one( 'touchstart', function() {
            $( document.body ).removeClass( 'pointer-device' );
            $( document.body ).addClass( 'touch-device' );
        } );
    },
    content: {
        init: function() {
            //Global
            theme.smoothScroll.init();
            theme.viewportChecker.init();
            theme.parallax.init();
            theme.selectric.init();
            theme.stickyHeader.init();
            theme.hamburger.init();
            theme.videoBackground.init();
            theme.fullScreenVideo.init();

            //Page specific
            theme.featuresCarousel.init();
            theme.slides.init();
            theme.slideshow.init();
            theme.gallery.init();
            theme.contactForm.init();
            theme.homepageBoxes.init();
            
            // theme.modal.init();

            theme.video.init();
            theme.image.init();
        }
    },
    video: {
        selector: 'video',
        init: function() {
            var self = this,
            $elements = $( self.selector );

            $elements.on( 'canplay', function (e) {
                $( this ).addClass('loaded');
            });
        }
    },
    image: {
        init: function() {
            var imgLoad = imagesLoaded( '.site' ),
            imageCount = $( '.site' ).find('img').length,
            loadedImagesCount = 0,
            currentProgress = 0,
            $progressElement = $( '[data-progress]' );

            imgLoad.on( 'progress', function( instance, image ) {
                var result = image.isLoaded ? 'loaded' : 'broken';

                if ( result === 'loaded' ) {
                    $( image.img ).addClass( 'loaded' );
                }

                loadedImagesCount++;
            } );
        }
    },
    smoothScroll: {
        selector: 'a[href*="#"]',
        init: function() {
            var self = this,
            scroll = new SmoothScroll( self.selector, {
                ignore: '[data-scroll-ignore]',
                speed: 1000,
                offset: 40,
                easing: 'easeInOutCubic',
            } );
        }
    },
    modal: {
        selectors: {
            element:  '[data-modal]',
            trigger:  '[data-modal-trigger]',
            close:    '[data-modal-close]'
        },
        init: function() {
            var self  = this,
            $elements = $( self.selectors.elements );

            var $close = $( self.selectors.close ),
            modal = document.querySelector('.modal');

            disableBodyScroll( modal );
            $( document.body ).addClass( 'modal-opened' );

            $( document.body ).on( 'click', self.selectors.trigger, function(e) {
                e.preventDefault();

                disableBodyScroll( modal );
                $( document.body ).addClass( 'modal-opened' );

                return false;
            } );

            $( self.selectors.element ).on( 'click', self.selectors.close, function(e) {
                e.preventDefault();

                enableBodyScroll( modal );
                $( document.body ).removeClass( 'modal-opened' );

                return false;
            } );
        } 
    }, 
    viewportChecker: {
        selector: '*[data-viewport-checker="true"]',
        init: function() {
            var self = this,
            $elements = $( self.selector );

            $elements.viewportChecker( {
                classToAdd: 'visible',
                classToAddForFullView: 'full-visible',
                classToRemove: 'invisible',
                removeClassAfterAnimation: false,
                offset: '20%', 
                invertBottomOffset: true,
                repeat: false,
                scrollHorizontal: false,
                callbackFunction: function( elem, action ){
                    if ( action === 'add' ) {
                        elem.trigger( 'visible' );
                    }
                }
            } );

            $elements.on( 'visible', function(e) {
                var $this = $( this ),
                sequence = $this.attr( 'data-viewport-checker-sequence' );

                if ( typeof sequence !== typeof undefined && sequence !== false ) {
                    var $childElements = $this.find( '[data-viewport-checker-sequence-item]' );

                    $childElements.each( function( i ) {
                        var $childElement = $(this);
                        setTimeout(function() {
                            $childElement.addClass( sequence );
                        }, i * 250 );
                    } );
                }
            } );
        }
    },
    parallax: {
        boxes: [],
        init: function() {
            var self = this;
            // Store the window width
            var windowWidth = $( window ).width();

            // Create an animation for each ease box. Each with a different timing.
            Array.prototype.forEach.call( document.querySelectorAll( '.parallax' ), function( elem, i ) {
                var from = elem.getAttribute( 'data-parallax-from' );
                var to = elem.getAttribute( 'data-parallax-to' );

                var $elem = $( elem );

                from = ( from !== null ) ? from : '-50px';
                to = ( to !== null ) ? to : '50px';

                if ( $elem.hasClass( 'parallax--initialized' ) ) {
                    return;
                }
                else {
                    $elem.addClass( 'parallax--initialized' );
                }

                // Crate an instance for the current element and store the instance in an array.
                // We start the animation later using the instances from the array.
                self.boxes.push( basicScroll.create( {
                    elem: elem,
                    from: 'top-bottom',
                    to: 'bottom-top',
                    direct: true,
                    props: {
                        '--ty': {
                            from: from,
                            to: to
                        },
                        '--tr': {
                            from: '0deg',
                            to: '360deg'
                        }
                    }
                } ) )
            } );

            self.boxes.forEach( function( box ) {
                setTimeout( function() {
                    box.start();
                }, 50 );
            } );

            window.onresize = function() {
                if ( $( window ).width() != windowWidth ) {
                    windowWidth = $( window ).width();

                    self.recalculate();
                }
            }

            $( '.site' ).imagesLoaded( function() {
                self.recalculate();
            } );
        },
        recalculate: function() {
            var self = this;

            self.boxes.forEach( function( box ) {
                box.calculate();
            } );
        }
    },
    videoBackground: {
        init: function() {
            var self = this;

            self.loadVideo();

            $( window ).on( 'resize', function() {
                self.loadVideo();
            } );
        },
        loadVideo: function() {
            if ( $( window ).width() >= 768 ) {
                var $dynamicSource = $( '[data-video-background]' );

                $dynamicSource.each( function() {
                    var videoElement = this,
                    $videoElement = $( this ),
                    $videoSource = $videoElement.children( 'source' ),
                    source = $videoSource.attr( 'data-src' );

                    if ( source !== $videoSource.attr( 'src' ) && $videoSource.hasClass( 'loaded' ) === false ) {
                        $videoSource.attr( 'src', source );
                        $videoSource.addClass( 'loaded' );

                        setTimeout(function () {
                            videoElement.load();
                            videoElement.play();
                        }, 100);
                    }
                } );
            }
        }
    },
    fullScreenVideo: {
        selector: '*[data-fullscreen-video]',
        init: function() {
            var self = this,
            $element = $( this ),
            $trigger = $( '*[data-fullscreen-video-trigger]' ),
            $target = $( '*[data-fullscreen-video-target]' ),
            $close = $( '*[data-fullscreen-video-close]' ),
            videoSource = $target.find( 'iframe' ).attr( 'src' );

            $trigger.on( 'click', function() {
                $target.find( 'iframe' ).attr( 'src', videoSource );
                $( document.body ).addClass( 'full-screen-video-visible' );
                $target.addClass( 'visible' );
            } );

            $close.on( 'click', function(e) {
                e.preventDefault();
                $target.find('iframe').attr('src', '');
                $( document.body ).removeClass( 'full-screen-video-visible' );
                $target.removeClass( 'visible' );
            } );

            $( document ).keydown( function( e ) {
                if ( e.keyCode == 27 && $target.hasClass( 'visible' ) ) {
                    e.preventDefault();
                    $target.find('iframe').attr('src', '');
                    $( document.body ).removeClass( 'full-screen-video-visible' );
                    $target.removeClass( 'visible' );
                }
            } );
        }
    },
    stickyHeader: {
        init: function() {
            $( window ).on( 'scroll', function() {
                if ( $( this ).scrollTop() > 300 && !$( document.body ).hasClass( 'fixed-header' ) ) {
                    $( document.body ).addClass( 'fixed-header fixed-header-prepare' );

                    setTimeout( function() {
                        $( document.body ).removeClass( 'fixed-header-prepare' );
                        $( '.header' ).addClass( 'animate' );
                    }, 100 );
                }

                if ( $( this ).scrollTop() <= 300 && $( document.body ).hasClass( 'fixed-header' ) ) {
                    $( '.header' ).removeClass( 'animate' );

                    $( '.header' ).one( 'transitionend', function() {
                        $( document.body ).removeClass( 'fixed-header' );
                    } );
                }
            } );
        }
    },
    selectric: {
        selector: 'select',
        init: function() {
            var self = this,
            $elements = $( self.selector );

            $elements.selectric( {
                arrowButtonMarkup: '<b class="arrow"></b>',
                multiple: {
                    keepMenuOpen: true,
                }
            } );
        }
    },
    hamburger: {
        selector: '.hamburger',
        lock: false,
        init: function() {
            var self = this,
            $hamburger = $( self.selector ),
            $navigation = $( '.navigation' );

            $hamburger.on( 'click', function( e ) {
                e.preventDefault();
                var timeout = 1;

                if ( $( document.body ).hasClass( 'fixed-header' ) ) {
                    $( '.header' ).removeClass( 'animate' );

                    $( '.header' ).one( 'transitionend', function() {
                        $( document.body ).removeClass( 'fixed-header' );
                        $( document.body ).addClass( 'had-fixed-header' );
                    } );

                    timeout = 500;
                }

                setTimeout( function() {
                    $navigation.addClass( 'navigation--animate' );

                    if ( $( document.body ).hasClass( 'navigation-opened' ) ) {
                        self.unlockBody();

                        setTimeout( function() {
                            if ( $( document.body ).hasClass( 'had-fixed-header' ) ) {
                                $( document.body ).removeClass( 'had-fixed-header' ); 
                            }

                            $( document.body ).removeClass( 'navigation-opened' );
                        }, 100 );

                    }
                    else {
                        $( document.body ).addClass( 'navigation-opened' );

                        if ( $( document.body ).hasClass( 'fixed-header' ) ) {
                            $( document.body ).addClass( 'had-fixed-header' ); 
                        }

                        setTimeout( function() {
                            self.lockBody();
                        }, timeout );
                    }
                }, timeout );

            } );

            $( '.navigation__link' ).on( 'click', function() {
                self.unlockBody();

                setTimeout( function() {
                    if ( $( document.body ).hasClass( 'had-fixed-header' ) ) {
                        $( document.body ).removeClass( 'had-fixed-header' ); 
                    }

                    $( document.body ).removeClass( 'navigation-opened' );
                }, 100 );
            } )

            $( window ).on( 'resize', function( e ) {
                $navigation.removeClass( 'navigation--animate' );
            } );

            var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

            if ( iOS ) {
                document.addEventListener( 'touchmove', function(e) {
                    if( self.lock === true ){
                        e.preventDefault();
                    }
                }, { passive: false });  
            }
        },
        lockBody: function() {
            var self = this;
            self.lock = true;

            $( 'html, body' ).css( {
                overflow: "hidden"
            } );

        },
        unlockBody: function() {
            var self = this;
            self.lock = false;

            $( 'html, body' ).css( {
                overflow: ""
            } );
        }
    },
    featuresCarousel: {
        selector: '[data-mobile-carousel]',
        init: function() {
            var self = this,
            $mobileCarousel = $( self.selector );

            $mobileCarousel.each( function() {
                var $this = $( this );

                if ( $( window ).width() < 768) {
                    self.addCarousel( $this );
                }

                $( window ).on('resize', function() { 
                    if ( $( window ).width() >= 768 ) {
                        self.removeCarousel( $this );
                    } else {
                        self.addCarousel( $this );
                    }
                } );
            } );
        },
        addCarousel: function( $mobileCarousel ) {
            if ( $mobileCarousel.attr( 'data-mobile-carousel' ) === 'true' ) {
                return;
            }

            var padding = $mobileCarousel.attr( 'data-mobile-carousel-padding' );
            padding = ( padding !== undefined ) ? padding : '25%';

            $mobileCarousel.on( 'init', function() {
                var $this = $( this );
                $this.attr( 'data-mobile-carousel', 'true' );
            } );

            $mobileCarousel.slick( {
                slidesToShow: 1,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: padding,
                prevArrow: '<span class="slick-prev slick-arrow"></span>',
                nextArrow: '<span class="slick-next slick-arrow"></span>',
            } );
        },
        removeCarousel: function( $mobileCarousel ) {
            if ( $mobileCarousel.attr( 'data-mobile-carousel' ) === 'true' ) {
                $mobileCarousel.attr( 'data-mobile-carousel', 'false' );
                $mobileCarousel.slick( 'unslick' );
            }
        }
    },
    slideshow: {
        selector: '.services__service-slideshow',
        init: function() {
            var self = this,
            $slideshow = $( self.selector );

            $slideshow.slick( {
                slidesToShow: 1,
                dots: false,
                arrows: true,
                prevArrow: '<span class="slick-prev slick-arrow"></span>',
                nextArrow: '<span class="slick-next slick-arrow"></span>',
            } );

            $slideshow.imagesLoaded( function() {
                $slideshow.slick( 'refresh' );
            } );
        }
    },
    gallery: {
        selector: '.gallery__images',
        init: function() {
            var self = this,
            $gallery = $( self.selector );

            $gallery.slick( {
                slidesToShow: 1,
                dots: false,
                arrows: true,
                centerMode: true,
                centerPadding: '10%',
                prevArrow: '<span class="slick-prev slick-arrow"></span>',
                nextArrow: '<span class="slick-next slick-arrow"></span>',
            } );
        }
    },
    homepageBoxes: {
        selector: '.services__service-boxes',
        init: function() {
            var self = this,
            $boxes = $( self.selector );

            $boxes.on( 'click', '.services__service-box', function() {
                var $this = $( this );
                
                if ( $this.hasClass( 'active' ) ) {
                    $this.removeClass( 'active' );
                } else {
                    $boxes.find( '.services__service-box' ).removeClass( 'active' );
                    $this.addClass( 'active' );
                }
            } ); 
        }
    },
    slides: {
        selector: '.services__service-slides',
        init: function() {
            var self = this,
            $slides = $( self.selector );

            $slides.find( '.services__service-slide' ).eq(0).addClass( 'active' );

            $slides.on( 'click', '.services__service-slide', function() {
                var $this = $( this ),
                $startElement = $slides.find( '.services__service-slide.active' ),
                $animatedElements = $startElement.nextUntil( $this ).add( $this );

                if ( $this.hasClass( 'active' ) ) {
                    return;
                }

                if ( $this.index() < $startElement.index() ) {
                    $animatedElements = $( $startElement.prevUntil( $this ).add( $this ).get().reverse() );
                }
                $slides.find( '.services__service-slide' ).removeClass( 'active' );

                if ( $startElement.length < 1 ) {
                    $this.addClass( 'active' );
                } else {
                    $animatedElements.each( function(i) {
                        var $elem = $( this ),
                        $time = 75 * (i + 1);

                        setTimeout( function() {
                            $elem.addClass( 'active' );
                        }, $time );

                        if ( $elem.is( $this ) === false ) {
                            setTimeout( function() {
                                $elem.removeClass( 'active' );
                            }, $time * 2 );
                        }
                    } )
                }

            } );           
        }
    },
    contactForm: {
        selector: '.contact-form',
        init: function() {
            var self = this,
            $contactForm = $( self.selector ),
            $wpcf7       = $contactForm.find( '.wpcf7' ),
            $ctaButtons  = $( '[data-form-action]' ),
            $select      = $contactForm.find( 'select[name="your-service"]' );
            
            $ctaButtons.on( 'click', function() {
                var $this = $( this ),
                action = $this.attr( 'data-form-action' );

                $select.val( action ).selectric('refresh');
            } );

            $wpcf7.on( 'wpcf7:invalid', function(e, data) {
                var invalidFields = data.apiResponse.invalidFields;

                var scroll = new SmoothScroll();
                scroll.animateScroll( $wpcf7[0], false, { offset: 50 } );

                $.each( invalidFields, function(i, n) {
                    $( n.into ).find( '.selectric-wrapper' ).addClass( 'wpcf7-not-valid' );
                } );
            } );

            $wpcf7.on( 'wpcf7:beforesubmit', function(e, data) {
                $wpcf7.find( '.selectric-wrapper' ).removeClass( 'wpcf7-not-valid' );
            } );
        }
    }
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );